import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ViewAction } from '../../../view/BlockCard/actions/ViewAction';
import { DownloadAction } from '../../../view/BlockCard/actions/DownloadAction';
import { CardAction } from '../../../view/Card/types';
import { canShowAction } from '../../../utils/actions/can-show-action';
var isClientAction = function isClientAction(action) {
  return ['ViewAction', 'DownloadAction'].indexOf(action['@type']) > -1;
};
var getClientAction = function getClientAction(jsonLd, action) {
  switch (action['@type']) {
    case 'ViewAction':
      return ViewAction({
        url: jsonLd.url
      });
    case 'DownloadAction':
      return DownloadAction({
        url: jsonLd['atlassian:downloadUrl']
      });
  }
};
var isActionEnabled = function isActionEnabled(action, actionOptions) {
  switch (action['@type']) {
    case 'ViewAction':
      return canShowAction(CardAction.ViewAction, actionOptions);
    case 'DownloadAction':
      return canShowAction(CardAction.DownloadAction, actionOptions);
  }
  return true;
};
var getClientActionProps = function getClientActionProps(jsonLd, action, handler) {
  var clientAction = getClientAction(jsonLd, action);
  var clientActionInvokeOpts = {
    type: 'client',
    key: action.identifier,
    action: {
      type: action['@type'],
      promise: clientAction.promise
    }
  };
  // Send client actions through common invocation flow; for analytics
  // and, in future, in order to propagate state changes.
  return _objectSpread(_objectSpread({}, clientAction), {}, {
    promise: function promise() {
      return handler(clientActionInvokeOpts);
    }
  });
};
export var getActionsFromJsonLd = function getActionsFromJsonLd(jsonLd) {
  var actions = jsonLd && jsonLd['schema:potentialAction'];
  if (!actions) {
    return [];
  }
  if (actions && !Array.isArray(actions)) {
    actions = [actions];
  }
  return actions;
};
export function extractClientActions(jsonLd, handler, actionOptions) {
  var actions = getActionsFromJsonLd(jsonLd);
  var clientActions = actions.filter(function (action) {
    return isClientAction(action) && isActionEnabled(action, actionOptions);
  });
  var clientActionImpls = clientActions.map(function (action) {
    return getClientActionProps(jsonLd, action, handler);
  });
  return clientActionImpls;
}